import { Colors } from "../preset.constants";

export const datepickerPreset = {
    disabled: {
        background: Colors.DisabledBackground,
        color: Colors.DisabledColor
    },
    panel: {
        color: Colors.DefaultTextColor
    },
    header: {
        color: Colors.DefaultTextColor
    },
    dropdown: {
        color: Colors.DefaultTextColor
    },
    date: {
        color: Colors.DefaultTextColor
    },
    week: {
        day: {
            color: Colors.DefaultTextColor
        }
    },
    select: {
        month: {
            color: Colors.DefaultTextColor
        },
        year: {
            color: Colors.DefaultTextColor
        }
    }
}